// src/redux/settingDataSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { base_url } from '../../pages/Constants';

// Define the async thunk for fetching data
export const fetchSettingData = createAsyncThunk(
  'settingData/fetchData',
  async (_, { rejectWithValue }) => {
    const lang = localStorage.getItem('current_lang') || 'en';
    const user = JSON.parse(localStorage.getItem('authUser'));

    try {
      let response;
      if (user) {
        response = await axios.get(base_url + '/api/settings', {
          headers: {
            'Authorization': 'Bearer ' + user.token,
            'language': lang,
            'userid':user.id
          },
        });
      } else {
        response = await axios.get(base_url + '/api/settings', {
          headers: {
            language: lang,
          },
        });
      }
      return response.data;
    } catch (error) {
      if (user) {
        localStorage.removeItem('authUser');
      }
      return rejectWithValue(error.response ? error.response.data : error.message);
    }
  }
);

// Create a slice
const settingDataSlice = createSlice({
  name: 'settingData',
  initialState: {
    data: null,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchSettingData.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchSettingData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data;
      })
      .addCase(fetchSettingData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

// Export the reducer
export default settingDataSlice.reducer;
